export default "__VITE_ASSET__vPB7DBB7__"